<div class="content-wrapper">
    <div class="content-body">
        <ng-template #content>
            <div id="modal">
                <div class="modal-header font-weight-bold">
                    <h4 class="modal-title font-weight-bold" *ngIf="modalType === 'ADD_WITHDRAW_REQUEST'">Add Withdraw
                        Request</h4>
                    <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            (click)="modalService.dismissAll('')"
                    >
                        ×
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row" *ngIf="modalType === 'ADD_WITHDRAW_REQUEST'">
                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <form class="form mt-2 mb--8px" novalidate [formGroup]="addWithdrawRequestForm">
                                <div class="row mb-2">
                                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <fieldset class="form-group">
                                            <label>Amount</label>
                                            <input class="form-control" type="number" formControlName="amount"
                                                   placeholder="Amount">
                                        </fieldset>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-danger color-white mr-auto">
                        <i class="fas fa-times mr-1"></i>Cancel
                    </button>
                    <button class="btn btn-success color-white pull-right" [disabled]="submitting"
                            *ngIf="modalType === 'ADD_WITHDRAW_REQUEST'" (click)="submit()">
                        <i class="fas fa-floppy-o mr-1" *ngIf="!submitting"></i>
                        <i class="fas fa-spinner fa-pulse mr-1" *ngIf="submitting"></i>Submit
                    </button>
                </div>
            </div>
        </ng-template>
        <section id="withdraw-requests">
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <h2 class="mt-5px">Withdraw Requests</h2>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <button class="btn btn-primary pull-right color-white users-btn"
                            (click)="openWithdrawRequestOpenModal(content)">
                        <i aria-hidden="true" class="fa fa-plus-circle mr-8px"></i>Add Withdraw Request
                    </button>
                    <button class="btn btn-primary pull-right color-white users-btn mr-10px"
                            (click)="showSearch = !showSearch">
                        <i aria-hidden="true" class="fa fa-search mr-8px"></i>&nbsp;Search
                    </button>
                </div>
            </div>
            <div class="row search-card mt-3" *ngIf="showSearch">
                <div class="col-12">
                    <form class="form mt-2 mb--8px" novalidate [formGroup]="searchForm">
                        <div class="row">
                            <div class="col-md-4 col-lg-4 col-sm-4 col-xs-12">
                                <fieldset class="form-group">
                                    <input class="form-control" type="number" formControlName="amount"
                                           placeholder="Amount">
                                </fieldset>
                            </div>
                            <div class="col-md-4 col-lg-4 col-sm-4 col-xs-12">
                                <fieldset class="form-group">
                                    <select class="form-control" formControlName="status">
                                        <option value="">Select Status</option>
                                        <option [value]="withdrawRequestStatus.value"
                                                *ngFor="let withdrawRequestStatus of withdrawRequestStatuses">{{withdrawRequestStatus?.name}}</option>
                                    </select>
                                </fieldset>
                            </div>
                            <div class="col-md-4 col-lg-4 col-sm-4 col-xs-12 text-center">
                                <button class="btn btn-primary btn-block btn-raised color-white mr-2 users-btn"
                                        (click)="search()"
                                        [disabled]="submitting">
                                    <i class="fas fa-spinner fa-pulse mr-1" *ngIf="submitting"></i>Search
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="row mt-40px">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right">
                    <h4 class="text-italic font-weight-bold mr-50px">
                        <span>
                            <i class="fa fa-money mr-5px f_25 text-success" aria-hidden="true"></i>
                        </span>
                        <span>
                            &#8377;{{userData?.activation_amount}}
                        </span>
                    </h4>
                    <small class="text-italic text-danger">
                        Available Activation Amount
                    </small>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12">
                    <div class="card">
                        <div class="container-fluid">
                            <div class="row overflow-x-scroll overflow-table">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <table class="table table-list">
                                        <thead>
                                        <tr>
                                            <th class="text-center">
                                                <h6 class="mt-1 mb-1 font-weight-bold">S.No</h6>
                                            </th>
                                            <th class="text-center">
                                                <h6 class="mt-1 mb-1 font-weight-bold">Amount</h6>
                                            </th>
                                            <th class="text-center">
                                                <h6 class="mt-1 mb-1 font-weight-bold">Request Date Time</h6>
                                            </th>
                                            <th class="text-center">
                                                <h6 class="mt-1 mb-1 font-weight-bold">Status</h6>
                                            </th>
                                            <th class="text-center">
                                                <h6 class="mt-1 mb-1 font-weight-bold">Status Date Time</h6>
                                            </th>
                                            <th class="text-center">
                                                <h6 class="mt-1 mb-1 font-weight-bold">Remarks</h6>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody *ngIf="withDrawRequests && withDrawRequests.length > 0; else noDataToShow">
                                        <tr *ngFor="let withDrawRequest of withDrawRequests; let i = index">
                                            <td class="text-center">
                                                <h6 class="mt-1">
                                                    {{(pagination.page - 1) * (pagination.perpage ? pagination.perpage : 0) + i + 1}}.
                                                </h6>
                                            </td>
                                            <td class="text-center">
                                                &#8377; {{withDrawRequest?.amount | IndianNumber}}
                                            </td>
                                            <td class="text-center">
                                                {{withDrawRequest?.request_date_time}}
                                            </td>
                                            <td class="text-center">
                                                <span class="color-blue" *ngIf="withDrawRequest && withDrawRequest['status'] === 'PENDING'">Pending</span>
                                                <span class="text-success" *ngIf="withDrawRequest && withDrawRequest['status'] === 'PROCESSED'">Processed</span>
                                                <span class="text-danger" *ngIf="withDrawRequest && withDrawRequest['status'] === 'REJECTED'">Rejected</span>
                                            </td>
                                            <td class="text-center">
                                                {{withDrawRequest?.status_date_time}}
                                            </td>
                                            <td class="text-center">
                                                {{withDrawRequest?.remarks}}
                                            </td>
                                        </tr>
                                        </tbody>
                                        <ng-template #noDataToShow>
                                            <tbody>
                                            <tr>
                                                <td colspan="6" class="text-center">
                                                    <h5>No data to show</h5>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </ng-template>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row pagination-table">
                <ngb-pagination (pageChange)="onPageChange($event)"
                                [(page)]="pagination.page"
                                [boundaryLinks]="true"
                                [collectionSize]="pagination.total"
                                [maxSize]="5"
                                [pageSize]="pagination.perpage">
                </ngb-pagination>
            </div>
        </section>
    </div>
</div>

